<template>
  <div class="razorpay-checkout">
    <!-- Hidden div for functionality -->
    <div style="display: none"></div>
  </div>
</template>

<script>
export default {
  name: 'RazorpayCheckout',
  props: {
    planUserEmail: String,
    planUserName: String,
    planUserContact: String,
    orgInfo: Object,
    paymentType: {
      type: String,
      enum: ['MONTHLY', 'YEARLY'],
      required: true
    }
  },
  data() {
    return {
      scriptLoaded: false,
      loading: false
    }
  },
  methods: {
    loadRazorpay() {
      return new Promise((resolve) => {
        if (window.Razorpay) {
          resolve(true)
          return
        }
        const script = document.createElement('script')
        script.src = 'https://checkout.razorpay.com/v1/checkout.js'
        script.onload = () => {
          this.scriptLoaded = true
          resolve(true)
        }
        script.onerror = () => {
          resolve(false)
        }
        document.body.appendChild(script)
      })
    },
    async openPayment(options) {
      this.loading = true
      try {
        const isLoaded = await this.loadRazorpay()
        if (!isLoaded) {
          this.$emit('error', 'Razorpay SDK failed to load. Please check your internet connection.')
          return
        }

        const defaultOptions = {
          key: 'rzp_test_RsjI2YFWzhYic2', // Default Test Key
          // key: 'rzp_live_RsKrxaK1p6RXYh',
          name: 'CualityWork',
          currency: 'INR',
          image: 'https://cualitywork.com/logo.png',
          theme: {
            color: '#3399cc'
          },
          handler: (response) => {
            this.$emit('success', response)
          },
          modal: {
            ondismiss: () => {
              this.$emit('closed')
            }
          }
        }

        const finalOptions = {
          ...defaultOptions,
          ...options,
          theme: {
            ...defaultOptions.theme,
            ...(options.theme || {})
          },
          prefill: {
            ...(options.prefill || {})
          },
          notes: {
            ...(options.notes || {})
          }
        }

        const userHandler = options.handler
        finalOptions.handler = (response) => {
          this.$emit('success', response)
          if (userHandler) {
            userHandler(response)
          }
        }

        const rzp = new window.Razorpay(finalOptions)

        // Handle failure/error events if Razorpay supports them in this SDK version
        rzp.on('payment.failed', (response) => {
          this.$emit('failure', response)
        })

        rzp.open()
      } catch (error) {
        console.error('Razorpay Error:', error)
        this.$emit('error', error)
      } finally {
        this.loading = false
      }
    },
    async processPayment(plan) {
      if (!plan) return

      if (plan.price === 0) {
        this.$emit('success', { status: 'skipped', plan: plan.name })
        return
      }

      this.loading = true

      try {
        const startRes = await this.$axios.post('/cualitywork/razorpay/create-order', {
          orgId: this.orgInfo?.orgId,
          planId: this.orgInfo?.planId,
          orgName: this.orgInfo?.orgName,
          amount: plan.price,
          contactName: this.planUserName,
          contactEmail: this.planUserEmail,
          contactMobile: this.planUserContact
        })

        const { order, customerId } = startRes.data

        const isLoaded = await this.loadRazorpay()
        if (!isLoaded) {
          this.$emit('error', 'Razorpay SDK failed to load. Please check your internet connection.')
          return
        }

        const options = {
          key: 'rzp_test_RsjI2YFWzhYic2',
          amount: order.amount * 100,
          currency: order.currency,
          name: this.planUserName || 'CualityWork',
          description: `Subscription for ${plan.name}`,
          order_id: order.id,
          customer_id: customerId,
          image: 'https://cualitywork.com/logo.png',
          theme: {
            color: '#3399cc'
          },
          prefill: {
            name: this.planUserName,
            email: this.planUserEmail,
            contact: this.planUserContact
          },
          handler: async (response) => {
            try {
              await this.$axios.post('/cualitywork/razorpay/verify-payment', {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
                orgId: this.orgInfo?.orgId,
                planId: this.orgInfo?.planId,
                paymentType: this.paymentType,
                customerId: customerId,
                amount: plan.price
              })
              this.$emit('success', response)
            } catch (err) {
              console.error('Verification failed', err)
              this.$emit('error', err)
              alert('Payment verification failed')
            }
          },
          modal: {
            ondismiss: () => {
              this.$emit('closed')
            }
          }
        }

        const rzp = new window.Razorpay(options)

        rzp.on('payment.failed', (response) => {
          this.$emit('failure', response)
        })

        rzp.open()
      } catch (err) {
        console.error('Payment failed', err)
        this.$emit('error', err)
        alert('Unable to initiate payment')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
/* Minimal styling overrides if needed */
</style>
